import HBIcon from "@/components/HBIcon";
import { SHORTCUT } from "@/constants/shortcut";
import { getNextViewImageSetp } from "@/utils/getHistorySetp";
import isEditingElement from "@/utils/isEditingElement";
import { useKeyPress } from "ahooks";
import { When } from "react-if";
import styles from "./index.module.less";
export default function ModalOperate(props) {
  const { onClose, onOperation, nextPin, prevPin } = props;
  // 快捷键：上一个采集
  useKeyPress(
    SHORTCUT.PREV_PIN,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }
      if (prevPin) {
        onOperation(prevPin);
      }
    },
    {
      exactMatch: true,
    }
  );

  // 快捷键：下一个采集
  useKeyPress(
    SHORTCUT.NEXT_PIN,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      if (nextPin) {
        onOperation(nextPin);
      }
    },
    {
      exactMatch: true,
    }
  );
  const goPrePin = () => {
    let setp = getNextViewImageSetp();
    history.go(-1 * setp);
  };
  return (
    <div className={styles.operate}>
      <div className={styles.mask} onClick={onClose}></div>
      <a
        className={styles.close}
        onClick={onClose}
        data-tooltip="关闭 [ESC]"
        data-tooltip-position="bottom"
      >
        <HBIcon type="ic_close" />
      </a>
      <a className={styles.backBtn} onClick={goPrePin}>
        <HBIcon type="ic_arrowThinLeft" />
        <span className={styles.backDesc}>返回</span>
      </a>
      <div className={styles.operation}>
        <When condition={nextPin}>
          <a
            className={styles.next}
            title="下一张"
            onClick={() => onOperation(nextPin)}
          >
            <HBIcon type="ic_chevron_right" />
          </a>
        </When>
        <When condition={prevPin}>
          <a
            className={styles.prev}
            title="上一张"
            onClick={() => onOperation(prevPin)}
          >
            <HBIcon type="ic_chevron_left" />
          </a>
        </When>
      </div>
    </div>
  );
}
